<div
  class="hero-banner"
  [style.background-image]="
    'url(' + (heroContent?.backgroundImage || placeholder) + ')'
  "
>
  <div class="hero-content">
    <ion-item class="fs-3 ion-padding-top" lines="none"> </ion-item>
    <div class="ion-padding ion-margin-top">
      <h4 class="fs-4 font600 white-text-color">{{ heroContent?.display_name }}</h4>
      <p class="fs-4 font500 white-text-color">
        {{ heroContent?.description }}
      </p>
    </div>
    <ion-grid *ngIf="heroContent.smallIcons.length > 0" [fixed]="true">
      <ion-row>
        <ion-col
          class="ion-text-center"
          *ngFor="let item of heroContent.smallIcons"
        >
          <ion-chip
            mode="ios"
            [routerLink]="item.landing_url"
            (click)="handleLandingUrl(item.landing_url,value)"
            class="secondary-chip ion-justify-content-center"
          >
            <img [src]="item.carousel_img" [alt]="item.title" class="icon_wh" />
            <ion-label class="fs-2 font500">{{ item.value }}</ion-label>
          </ion-chip>
          <div class="fs-2 font500 white-text-color">{{ item.title }}</div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
